import { createAction, props } from '@ngrx/store';
import {
  CalculationCostItemsDTO,
  CalculationDetailedDTO,
  CalculationExtrasDistributionItemsDTO,
  CalculationFinancialCostsDTO,
  CalculationMissingDpbsDTO,
  CalculationReadModelDTO,
  CalculationSettingsDTO,
  CalculationSummaryDTO,
  CalculationSummaryResponseDTO,
  CalculationCustomerPriceDTO,
  CalculationTotalDTO,
  EscalationDTO,
} from '../../openapi';

export const loadCalculation = createAction('[Calculation] Load Calculation', props<{ id: number }>());

export const openCalculation = createAction('[Calculation] Open Calculation', props<{ id: number }>());

export const closeCalculation = createAction('[Calculation] Close Calculation', props<{ id: number | undefined }>());

export const resetCalculationState = createAction('[Calculation] Reset Calculation State');

export const loadCalculationSuccess = createAction(
  '[Calculation] Load Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const clearStore = createAction('[Calculation] Clear');

export const loadCalculationFailure = createAction('[Calculation] Load Failure', props<{ error: string }>());

// Calculation Summary

export const saveCalculationSummary = createAction(
  '[Calculation] Summary',
  props<{ id: number; summary: CalculationSummaryDTO; redirectUrl: string }>()
);

export const saveCalculationSummarySuccess = createAction(
  '[Calculation] Summary Success',
  props<{ summary: CalculationSummaryResponseDTO }>()
);

// Calculation Settings

export const saveCalculationSettings = createAction(
  '[Calculation] Settings',
  props<{ id: number; settings: CalculationSettingsDTO; redirectUrl: string }>()
);

export const saveCalculationSummaryFailure = createAction('[Calculation] Summary Failure', props<{ error: string }>());

export const saveCalculationSettingsSuccess = createAction(
  '[Calculation] Settings Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationSettingsFailure = createAction(
  '[Calculation] Settings Failure',
  props<{ error: string }>()
);

// Calculation Detailed

export const saveCalculationDetailed = createAction(
  '[Calculation] Detailed',
  props<{ id: number; details: CalculationDetailedDTO; redirectUrl: string }>()
);

export const saveCalculationDetailedSuccess = createAction(
  '[Calculation] Detailed Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationDetailedFailure = createAction(
  '[Calculation] Detailed Failure',
  props<{ error: string }>()
);

// Financial Costs

export const saveCalculationFinancialCosts = createAction(
  '[Calculation] Financial Costs',
  props<{ id: number; costs: CalculationFinancialCostsDTO; redirectUrl: string }>()
);

export const saveCalculationFinancialCostsSuccess = createAction(
  '[Calculation] Financial Costs Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationFinancialCostsFailure = createAction(
  '[Calculation] Financial Costs Failure',
  props<{ error: string }>()
);

// Escalations

export const saveCalculationEscalations = createAction(
  '[Calculation] Escalations',
  props<{ id: number; escalations: EscalationDTO[]; close: boolean; redirectUrl: string }>()
);

export const saveCalculationEscalationsSuccess = createAction(
  '[Calculation] Escalations Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationEscalationsFailure = createAction(
  '[Calculation] Escalations Failure',
  props<{ error: string }>()
);

// Cost Items (Erection & Startup)

export const saveCalculationCostItems = createAction(
  '[Calculation] Cost Items',
  props<{ id: number; costItems: CalculationCostItemsDTO; redirectUrl: string }>()
);

export const saveCalculationCostItemsSuccess = createAction(
  '[Calculation] Cost Items Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationCostItemsFailure = createAction(
  '[Calculation] Cost Items Failure',
  props<{ error: string }>()
);

// Extras Distribution

export const saveCalculationExtrasDistribution = createAction(
  '[Calculation] Extras Distribution',
  props<{ id: number; extrasDistribution: CalculationExtrasDistributionItemsDTO; redirectUrl: string }>()
);

export const saveCalculationExtrasDistributionSuccess = createAction(
  '[Calculation] Extras Distribution Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationExtrasDistributionFailure = createAction(
  '[Calculation] Extras Distribution Failure',
  props<{ error: string }>()
);

// Missing DPBs

export const saveCalculationMissingDpbs = createAction(
  '[Calculation] Missing DPBs',
  props<{ id: number; missingDpbs: CalculationMissingDpbsDTO; redirectUrl: string }>()
);

export const saveCalculationMissingDpbsSuccess = createAction(
  '[Calculation] Missing DPBs Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationMissingDpbsFailure = createAction(
  '[Calculation] Missing DPBs Failure',
  props<{ error: string }>()
);

export const saveCalculationTotal = createAction(
  '[Calculation] Total',
  props<{ id: number; total: CalculationTotalDTO; redirectUrl: string }>()
);

export const saveCalculationTotalSuccess = createAction(
  '[Calculation] Total Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationTotalFailure = createAction('[Calculation] Total Failure', props<{ error: string }>());

export const saveCalculationCustomerPrice = createAction(
  '[Calculation] Customer Price',
  props<{ id: number; customerPrice: CalculationCustomerPriceDTO; redirectUrl: string }>()
);

export const saveCalculationCustomerPriceSuccess = createAction(
  '[Calculation] Customer Price Success',
  props<{ calculation: CalculationReadModelDTO }>()
);

export const saveCalculationCustomerPriceFailure = createAction(
  '[Calculation] Customer Price Failure',
  props<{ error: string }>()
);

export const clearError = createAction('[Calculation] Clear Error');
